import React from "react";
import { css } from "@emotion/react";
import { Card } from "main/javascripts/components/atoms/Card";
import { RectSkeleton } from "main/javascripts/components/skeleton/RectSkeleton";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import {
  backgroundColor,
  borderColor,
} from "main/javascripts/styles/base/colorStyle";
import { maxWidth } from "main/javascripts/styles/base/maxWidthStyle";

export const HotelRoomCardSkeleton: React.FC = (): React.ReactElement => {
  const planCount = 2;
  return (
    <Card styleKey="cardNoHover">
      <div css={roomBlockStyle}>
        <div css={titleSkeletonStyle}>
          <RectSkeleton />
        </div>
        <div css={roomImageStyle}>
          <div css={imageSkeletonStyle}>
            <RectSkeleton />
          </div>
        </div>
      </div>
      <div css={planBlockStyle}>
        {Array.from(Array(planCount)).map((_, index) => {
          return (
            <div css={planItemStyle} key={index}>
              <div css={planOptionSkeletonStyle}>
                <RectSkeleton />
              </div>
              <div css={planOptionSkeletonStyle}>
                <RectSkeleton />
              </div>
              <div css={planPriceSkeletonStyle}>
                <RectSkeleton />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

const roomBlockStyle = css`
  padding: ${space.block2x} ${space.block} 0;
  max-width: ${maxWidth.page1col};
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;
  padding-top: ${space.atom1_5x};
  ${moreThanBreakpoint("tablet")} {
    background-color: ${backgroundColor.primaryLightColor};
    width: 50%;
    padding-bottom: ${space.atom};
  }
  ${moreThanBreakpoint("desktop")} {
    width: 40%;
  }
`;
const roomImageStyle = css`
  position: relative;
  padding: 56.25% 0 0;
  margin: ${space.atom} -${space.atom};
  ${moreThanBreakpoint("tablet")} {
    padding: 62.5% 0 0;
    margin: ${space.atom} ${space.atom} ${space.atom3x};
  }
`;
const planBlockStyle = css`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${borderColor.primaryLightColor};
  margin-top: ${space.atom2x};
  ${moreThanBreakpoint("tablet")} {
    margin-top: 0;
    width: 50%;
    border-top: 0;
    border-left: 1px solid ${borderColor.primaryLightColor};
  }
  ${moreThanBreakpoint("desktop")} {
    width: 60%;
  }
`;
const planItemStyle = css`
  border-top: 1px solid ${borderColor.primaryLightColor};
  padding: ${space.atom2x};
  &:first-of-type {
    border-top: 0;
  }
  ${moreThanBreakpoint("tablet")} {
    flex: 1;
  }
`;
const titleSkeletonStyle = css`
  width: 50%;
  height: 1.5rem;
  margin: ${space.atom};
`;
const imageSkeletonStyle = css`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
`;
const planOptionSkeletonStyle = css`
  width: 25%;
  height: 1.125rem;
  margin-bottom: ${space.atom};
`;
const planPriceSkeletonStyle = css`
  width: 30%;
  height: 2rem;
  margin: 1rem 0 0 auto;
`;
